import { useMutation, useQuery, useQueryClient } from "react-query";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { windowDisplayAdsQueryKeys } from "./queryKeys";
import { BunnyStorageObject, IWindowDisplayAd, WindowDisplayAdCreate, WindowDisplayAdUpdate } from "../../models/windowDisplay/WindowDisplayAd";

export function useWindowDisplayAds(windowDisplayId: string) {
  const queryClient = useQueryClient();
  const { get, post, put, del } = useApiHelper();

  const ads = useQuery({
    queryKey: windowDisplayAdsQueryKeys.all(windowDisplayId),
    queryFn: () =>
      get(`/windowdisplay/ads/${windowDisplayId}`) as unknown as IDefaultResponseWithData<IWindowDisplayAd[]>,
    refetchOnWindowFocus: false,
    enabled: !!windowDisplayId,
  });

  const videos = useQuery({
    queryKey: "windowDisplayAdVideos",
    queryFn: () =>
      get(`/windowdisplay/ads/videos`) as unknown as IDefaultResponseWithData<BunnyStorageObject[]>,
    refetchOnWindowFocus: false,
  });

  const create = useMutation(
    (data: WindowDisplayAdCreate) => post(`/windowdisplay/ads/${data.windowDisplayId}`, data),
    {
      onSuccess: (_, data) => {
        queryClient.invalidateQueries(windowDisplayAdsQueryKeys.all(data.windowDisplayId));
      },
    }
  );

  const update = useMutation(
    (data: WindowDisplayAdUpdate) =>
      put(`/windowdisplay/ads/${data.id}`, data),
    {
      onSuccess: (_, data) => {
        queryClient.invalidateQueries(windowDisplayAdsQueryKeys.all(data.windowDisplayId));
      },
    }
  );

  const remove = useMutation(
    (id: string) => del(`/windowdisplay/ads/${id}`),
    {
      onSuccess: (_) => {
        queryClient.invalidateQueries(windowDisplayAdsQueryKeys.all(windowDisplayId));
      },
    }
  );

  return { ads, videos, create, update, remove };
}

